export function arraysEqual(left, right) {
  if (left.length !== right.length) return false;
  return left.every((value, index) => value === right[index]);
}

export function sanitizeLocationStack(rawValue, items) {
  const orderedIds = items.map((item) => item.id);
  const nextIds = new Set(Array.isArray(rawValue) ? rawValue : []);
  return orderedIds.filter((id) => nextIds.has(id));
}

export function buildLocationStackState(locationState, stateKey, nextStack) {
  const nextState = { ...(locationState || {}) };
  if (nextStack.length > 0) nextState[stateKey] = nextStack;
  else delete nextState[stateKey];
  return Object.keys(nextState).length > 0 ? nextState : null;
}

export function shouldNavigateBackForStackClose({
  openStack,
  previousOpenStack,
  locationStack,
  requestedSyncMode,
}) {
  return (
    requestedSyncMode !== "replace" &&
    openStack.length < previousOpenStack.length &&
    arraysEqual(locationStack, previousOpenStack)
  );
}
